var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaydonAnimatedLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e2H1wk6dUMV100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.48 51.854",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9353 17611.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6509-235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e2H1wk6dUMV4",
    d: "M76.441,159.248l-.641-.641v-31.066l.641-.641h6.54l.641.641v18.406h13.611v-18.406l.641-.641h6.54l.641.641v31.067l-.641.641h-6.54l-.641-.641v-11.954h-13.611v11.954l-.641.641h-6.54v-.001Z",
    transform: "translate(-15937.8-17492)",
    opacity: 0,
    fill: "#0A1E5B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV5_to",
    transform: "translate(-16153.4,-17517.63456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e2H1wk6dUMV5",
    d: "M353.1,126.9h7.932l6.319,12.064L373.67,126.9h7.888l.641.641-10.915,17.235v13.832l-.685.641h-6.5l-.641-.641v-13.833L352.5,127.541l.6-.641Z",
    transform: "translate(0,0)",
    opacity: 0,
    fill: "#0A1E5B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV6_to",
    transform: "translate(-16269,-17468.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e2H1wk6dUMV6",
    d: "M515.417,159.248h-13.876l-.641-.641v-31.066l.641-.641h13.876c8.949,0,14.318,6.806,14.318,16.174c0,9.391-5.435,16.174-14.318,16.174Zm-6.695-6.143h3.27c5.436,0,9.9-2.872,9.9-10.031s-4.662-10.031-9.9-10.031h-3.27v20.063-.001Z",
    transform: "translate(0,0)",
    opacity: 0,
    fill: "#0A1E5B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV7_to",
    transform: "translate(-16380.216639,-17518.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e2H1wk6dUMV7",
    d: "M643.9,141.594c0-9.523,5.436-16.594,15.29-16.594s15.29,7.026,15.29,16.594-5.48,16.55-15.29,16.55-15.29-7.071-15.29-16.55ZM659.213,152c4.463,0,7.468-3.425,7.468-10.407s-2.806-10.451-7.468-10.451-7.468,3.557-7.468,10.451s2.805,10.407,7.468,10.407Z",
    transform: "translate(0,0)",
    opacity: 0,
    fill: "#0A1E5B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV8_to",
    transform: "translate(-16501.4,-17468.0205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e2H1wk6dUMV8",
    d: "M819.8,158.607l-12.683-27.134v27.134l-.641.641h-6.5l-.685-.641v-31.066l.685-.641h5.48l.685.641L819.1,155.05v-27.509l.641-.641h6.54l.641.641v31.067l-.641.641h-5.833l-.641-.641-.007-.001Z",
    transform: "translate(0,0)",
    opacity: 0,
    fill: "#0A1E5B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV9_to",
    transform: "translate(-16052.1,-17471.856681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e2H1wk6dUMV9",
    d: "M235.315,145.947l3.535-9.346v0l3.579,9.346h-7.114Zm-.265.707l-4.508,11.954-.641.641h-6.761l-.641-.641l12.926-31.2.729-.508h5.48l.729.508l12.948,31.2-.641.641h-6.76l-.641-.641-4.569-11.954h-7.65Z",
    transform: "translate(0,0)",
    opacity: 0,
    fill: "#0A1E5B",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV10",
    transform: "translate(-9353-17611.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV11_to",
    transform: "translate(13.668488,32.463485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV11_tr",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.668488,-32.463485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.3,395.549v1.3L291.989,375.2v-1.3L280.3,395.549Z",
    transform: "translate(-272.476-352.911)",
    fill: "#0A1E5B"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,280.628l-.644-.644h-6.529l-.644.644v32.827v0v10.458l.644.644h6.529l.644-.644v-21.56",
    transform: "translate(-245.285-279.983)",
    fill: "#0A1E5B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e2H1wk6dUMV14_to",
    transform: "translate(-312.86,-350.935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.134,376.382v0l-.01-4.382-.644-.644h-6.48l-.691.644.007,4.385v0l.048,25.763.644.644h6.482l.691-.644-.047-25.766Z",
    transform: "translate(0,0)",
    fill: "#0A1E5B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaydonAnimatedLogoDark);
export default __webpack_public_path__ + "static/media/haydon-animated-logo-dark.fd7e6c9ebdc1c26f7e1351e19132b88c.svg";
export { ForwardRef as ReactComponent };